<template>
  <div class="code">
    <qriously
      :value="codeSrc"
      :size="codeSize"
    />
  </div>
</template>

<script>
import { remToPx } from "@/tools";
export default {
  name: "Code",
  props: {
    codeSrc: String
  },
  computed: {
    // 二维码尺寸
    codeSize() {
      return remToPx(1.97);
    }
  }
};
</script>

<style lang="scss">
.code {
  canvas {
    display: block;
    border: 1px solid #b7bfc2;
    background: #fcfeff;
    opacity: 0.6;
  }
}
</style>



